const doc = [({"da":({"js":({"admin":({"agenda_items":({"create_card":({"create_agenda_item":"Opret dagsordenspunkt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;